import {
  ContactOptionsSection,
  EmergencyInfoSection,
  VisitOfficeSection,
  PopularTopicsSection,
  ServiceStandardsSection,
  DataProtectionSection,
} from "@features/residential/components";

interface ContactPageProps {
  hero: React.ReactNode;
  footer?: React.ReactNode;
}

export default function ContactPage({ hero, footer }: ContactPageProps) {
  return (
    <div className="w-full flex flex-col bg-white">
      {hero}
      <ContactOptionsSection />
      <EmergencyInfoSection />
      <VisitOfficeSection />
      <PopularTopicsSection />
      <ServiceStandardsSection />
      <DataProtectionSection />
      {footer}
    </div>
  );
}
